module.exports = __webpack_public_path__ + "static/media/oddylabs.fe8bf256.webp";